<template>
	<div class="contact">

		<input type="text" v-model="data.name" :placeholder="$t('contact.name')"/>
		<input type="email" v-model="data.email" :placeholder="$t('contact.email')"/>
		<input type="text" v-model="data.number" :placeholder="$t('contact.number')"/>
		<textarea v-model="data.message" :placeholder="$t('contact.message')">
			
		</textarea>

		<button @click="send()" v-if="!loading">
			{{$t('contact.send')}}
		</button>

		<pulse-loader v-else :loading="true" color="#2da8d8"></pulse-loader>

		<router-link v-if="!loading" to="/">{{$t('contact.back')}}</router-link>
	</div>
</template>
<script>

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default{
	name: 'Contact',
	components: {
		'pulse-loader': PulseLoader
	},
	data(){
		return {
			data: {

			},
			loading: false
		}
	},
	methods:{
		validate(){
			let { data } = this
			return new Promise((resolve, reject) => {
				if(!data.name){
					reject(this.$t('notifications.error.name'))
				}else if(!data.email){
					reject(this.$t('notifications.error.email'))
				}else if(!data.number){
					reject(this.$t('notifications.error.number'))
				}else if(!data.message){
					reject(this.$t('notifications.error.message'))
				}else if(!data.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){
					reject(this.$t('notifications.error.email_wrong'))
				}else resolve(true)
			})
		},
		send(){
			this.loading = true
			this.validate()
			.then(success => {
				this.$api.send(this.data)
				.then(res => res.json())
				.then(response => {
					if(!response.error)
						this.reset()
					else{
						this.loading = false
						this.$notify({
						  group: 'foo',
						  type: 'error',
						  title: 'Server Error',
						  text: error
						})
					}

				})
			})
			.catch(err => {
				this.loading = false
				this.$notify({
				  group: 'foo',
				  type: 'error',
				  title: this.$t('notifications.error_title'),
				  text: err
				})
			})
		},
		reset(){
			this.$notify({
			  group: 'foo',
			  type: 'success',
			  title: this.$t('notifications.title_success'),
			  text: this.$t('notifications.message_success')
			})
			for(let x in this.data){
				this.data[x] = null
			}
			this.loading = false
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/Contact.vue